import RootNavigation from "./components/navigation/RootNavigation";

export default function App() {
  return <RootNavigation />;
}
